import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	warningIconAccessibilityLabel: {
		id: 'language-settings.sidebar-v4-translations.warning-icon-accessibility-label',
		defaultMessage: 'Translations missing',
		description:
			'Label for a warning icon. Used for screen readers. The icon indicates that there are translations that need review.',
	},
});
